<div class="dashboard">
  <app-parent-menu [title]="patientName || 'Take data'" [patients]="patients" [selectedPatientID]="patientID" (patientChanged)="switchPatient($event)">
    <a header-actions class="side-menu-button2" routerLink="/parent/home" [queryParams]="{patientID: patientID}">Sessions</a>
  </app-parent-menu>

  @if (loading) { <app-loading-indicator /> }
  @if (errorMessage) { <div class="alert" role="alert">{{ errorMessage }}</div> }
  @if (!loading && parentSessionService.getPatientSession()) {
  <app-session-collection [started]="true" [timerText]="timerString" [busy]="finishing" [behaviors]="behaviors"
    [groups]="collectionGroups" [navigation]="collectionNavigation" [subTargetsDictionary]="subTargetsDictionary" [promptSchedules]="promptSchedules"
    [bottomTargets]="false" [programInstructions]="false" [showEmptyMessage]="true"
    [playlistTitle]="selectedPlaylist?.PlaylistName ?? ''" [playlistInstructions]="selectedPlaylist?.Details"
    (end)="finish()" (navigationSelected)="selectCollectionItem($event)" />
  }
</div>
